import Vue from 'vue'
import Vuex from 'vuex'

import {
  getItemComments,
  openLoginModal,
  openSignupModal,
  destroy as destroyComment,
  create as createComment,
  update as updateComment
} from '../../actions/comment_actions';

import {
  createInvitation,
  getInvitations
} from '../../actions/invitation_actions';

import { getFeatures } from '@/src/actions/general_actions';
import { getConfiguration } from '@/src/actions/configuration_actions';
import { updateItem, getItem, annotate } from '../../actions/item_actions';
import { getCurrentOrganization, reloadCurrentOrganization } from '../../actions/organization_actions';
import { searchTemplates, applyTemplate } from '../../actions/template_actions.js';
import { getUser, searchUsers } from '../../actions/user_actions';
import { searchCallToActions, getCallToAction } from '../../actions/call_to_action_actions.js';
import { createSubscription } from '@/src/actions/subscription_actions';

import { getAnalytics, updateStats } from '../../actions/analytics_actions';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    item: gon.item,
    currentOrganization: { id: undefined, attributes: {} },
    itemOrganization: gon.itemOrganization,
    features: {},
    user: { id: null, attributes: {}},
    comments: [],
    stats: [],
    selectedMobileOption: 'overview',
    call_to_action: {
      id: null,
      attributes: {
        text: "My Custom Button",
        link: null,
        appearance: "cta-button-below",
        button_color: "#3f94fd",
        text_color: "#ffffff",
        corner_style: "cta-rounded",
        display_action: true
      }
    }
  },
  mutations: {
    setCurrentOrganization: (state, params) => state.currentOrganization = params,
    setComments: (state, params) => state.comments = params || [],
    setStats: (state, params) => state.stats = params || [],
    setItem: (state, params) =>  state.item = params || {},
    setItemOrganization: (state, params) => state.itemOrganization = params || {},
    setFeatures: (state, params) => state.features = params,
    setCallToAction: (state, params) => state.call_to_action = params || {},
    setOpenModal: (state, params) =>  state.openModal = params || false,
    setUser: (state, params) =>  state.user = params,
    selectMobileOption: (state, params) => state.selectedMobileOption = params,
    updateItem: (state, params) => state.item = { ...state.item, ...params } || {},
    updateCallToAction: (state, params) => state.call_to_action = { ...state.call_to_action, ...params } || {},
  },
  actions: {
    annotate,
    getCurrentOrganization,
    reloadCurrentOrganization,
    createInvitation,
    getFeatures,
    getInvitations,
    getItemComments,
    destroyComment,
    createComment,
    updateComment,
    getAnalytics,
    updateStats,
    getItem,
    getUser,
    searchUsers,
    updateItem,
    openLoginModal,
    openSignupModal,
    searchTemplates,
    applyTemplate,
    getConfiguration,
    searchCallToActions,
    getCallToAction,
    createSubscription
  },
  getters: {
    groupedCount: function(state, getters) {
      let count = 0;
      for(const key in getters.groupedStats) {
        count += getters.groupedStats[key].length
      }
      return count;
    },
    groupedStats: function(state) {
      const groupedStats = {};

      state.stats.forEach(stat => {
        const attrs = stat.attributes;

        const key = attrs.email;
        const percentage = attrs.data.viewed_pc ? Number.parseInt(attrs.data.viewed_pc) : 0;

        groupedStats[key] = groupedStats[key] || [];

        if (key == 'Anonymous User') {
          groupedStats[key].push({ percentage, created_at: attrs.created_at })
        } else if(percentage >= (groupedStats[key][0]?.percentage || 0)) {
          groupedStats[key] = [{ percentage, created_at: attrs.created_at }]
        }
      });

      return groupedStats;
    }
  }
});

export default store;
